import classnames from 'classnames';
import type { FunctionComponent } from 'react';

import { HighlightedCouponContainer } from '@/domains/loyalty/modules/HighlightedCoupon/HighlightedCouponContainer';
import { AddToCartBlock } from '@/domains/productDiscovery/ProductPage/b2c/components/AddToCartBlock/AddToCartBlock';
import { BlockV2 } from '@/domains/productDiscovery/ProductPage/b2c/components/Block/Block';
import { ProBlock } from '@/domains/productDiscovery/ProductPage/b2c/components/ProBlock/ProBlock';
import { Header } from '@/domains/productDiscovery/ProductPage/b2c/modules/Header/Header';
import { Title } from '@/domains/productDiscovery/ProductPage/b2c/modules/Title/Title';
import { LazyCompactVariantSelector } from '@/domains/productDiscovery/ProductPage/b2c/modules/Variants/VariantSelector/LazyCompactVariantSelector';
import { Carousel } from '@/domains/productDiscovery/ProductPage/common/components/Carousel/Carousel';
import { DeliveryPlace } from '@/domains/productDiscovery/ProductPage/common/modules/Delivery/Delivery';
import { GoodToKnow } from '@/domains/productDiscovery/ProductPage/common/modules/GoodToKnow/GoodToKnow';
import { HighlightedProductContainer } from '@/domains/sellerAdsManagement/SponsoredProducts/components/HighlightedProduct/HighlightedProduct.container';
import { MFAlternativeContainer } from '@/productDiscovery/ProductPage/b2c/modules/MFAlternative/MFAlternative.container';
import { Seller } from '@/productDiscovery/ProductPage/b2c/modules/Seller/Seller';
import { ModelsListManager } from '@/productDiscovery/ProductPage/b2c/modules/Variants/ModelsListManager';
import { GalleryWall } from '@/productDiscovery/ProductPage/common/components/GalleryWall/GalleryWall';

import styles from './styles.module.scss';

export const MainDetails: FunctionComponent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.left}>
        <Title />

        <div className={styles.header}>
          <Header />
        </div>

        <div className={styles.onlyDesktop}>
          <GalleryWall />
        </div>
        <Carousel className={classnames(styles.carousel, styles.onlyMobile)} />

        <BlockV2>
          <ModelsListManager />
        </BlockV2>

        <BlockV2 className={styles.onlyDesktop}>
          <LazyCompactVariantSelector />
        </BlockV2>
      </div>

      <div className={styles.right}>
        <BlockV2 noPadding>
          <AddToCartBlock />
        </BlockV2>

        <HighlightedCouponContainer />

        <BlockV2 className={styles.onlyMobile}>
          <LazyCompactVariantSelector />
        </BlockV2>

        <div>
          <ProBlock />
        </div>

        <BlockV2>
          <HighlightedProductContainer />
        </BlockV2>

        <BlockV2>
          <GoodToKnow />
        </BlockV2>

        <BlockV2>
          <DeliveryPlace />
        </BlockV2>

        <BlockV2>
          <MFAlternativeContainer />
        </BlockV2>

        <BlockV2 withSeparator>
          <Seller />
        </BlockV2>
      </div>
    </div>
  );
};

MainDetails.displayName = 'MainDetails';
